import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { signOut } from 'aws-amplify/auth'
import { clearSession } from '@/lib/session'
import { isAmplifyConfigured } from '@/lib/amplify'

export default function LogoutPage() {
  useEffect(() => {
    if (isAmplifyConfigured()) {
      signOut().catch(() => {}).finally(() => clearSession())
    } else {
      clearSession()
    }
  }, [])

  return <Navigate to="/login" replace />
}
